import DataNode from '../../../../interfaces/dataRoom/dataNode';
import Folder from './Folder';
import File, { FilePreview } from './File';
import DataRoomIcon from './dataRoomIcon';
import { Tree } from 'antd';
import FileMenu from './FileMenu';
export interface RenderTreeNodeArgs {
  item: DataNode;
  isMobile: boolean;
  isEditable: boolean;
  onClick: (e: any) => void;
  onMenuClick: (e: any, dataNode: DataNode) => void;
  t: any;
  onFileNameChange: (name: string) => void;
  onPreview: (file: FilePreview) => void;
  filesize: (size: number) => string;
  propertyId: string;
  selectedFolderId: string;
  checkedKeys;
}
const renderTreeNode = ({
  item,
  isMobile,
  isEditable,
  onClick,
  onMenuClick,
  t,
  onFileNameChange,
  onPreview,
  filesize,
  propertyId,
  selectedFolderId,
  checkedKeys,
}: RenderTreeNodeArgs) => {
  const extension = item.name?.split('.')?.pop();
  const renderItem = (item: DataNode) => {
    return item.isFolder ? (
      <Folder
        item={item}
        isMobile={isMobile}
        onClick={onClick}
        isEditable={isEditable}
        menu={
          <FileMenu
            item={item}
            isEditable={isEditable}
            t={t}
            onMenuClick={onMenuClick}
            propertyId={propertyId}
            selectedIds={checkedKeys}
          />
        }
      />
    ) : (
      <File
        item={item}
        onFileNameChange={onFileNameChange}
        onPreview={onPreview}
        isMobile={isMobile}
        filesize={filesize}
        onClick={onClick}
        menu={
          <FileMenu
            item={item}
            isEditable={isEditable}
            t={t}
            onMenuClick={onMenuClick}
            propertyId={propertyId}
            selectedIds={checkedKeys}
          />
        }
      />
    );
  };

  return (
    <Tree.TreeNode
      isLeaf={!item.isFolder}
      icon={<DataRoomIcon extension={extension} isFolder={item.isFolder} />}
      selectable={item.isFolder}
      title={renderItem(item)}
      key={item.id}
    >
      {(Array.isArray(item.nodes) ? item.nodes : []).map((node: DataNode) =>
        renderTreeNode({
          item: node,
          isMobile,
          isEditable,
          onClick,
          onMenuClick,
          t,
          onFileNameChange,
          onPreview,
          filesize,
          propertyId,
          selectedFolderId,
          checkedKeys,
        })
      )}
    </Tree.TreeNode>
  );
};
export default renderTreeNode;
